module.exports = __webpack_public_path__ + "static/media/si_ma.43dc0e7a.jpg";